// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2Cbzw","label":"SetPasswdForm_label__1HfM1"};